<script lang="ts">
    import type { LinkMetaDataFragment } from '$gql/graphql.js';
    import { cx } from '$lib/utils/cx.js';
    import { createEventDispatcher } from 'svelte';
    import { getClasses, getImageSize, restrictSize } from './Utils';
    import truncate from 'lodash/truncate';

    export let linkMetaData: LinkMetaDataFragment;
    export let maxSize: string | null = null;
    export let linkClass: string = '';
    export let imgClass: string = '';
    export let contentClass: string = '';
    export let titleClass: string = '';
    export let withButton = false;

    const dispatch = createEventDispatcher<{
        buttonclick: void;
    }>();

    let classes = getClasses({
        imageSize: restrictSize(getImageSize(linkMetaData.iconWidth || 0), maxSize),
        linkClass,
    });

    let imgWidth: number | null = null;

    $: {
        if (imgWidth !== null) {
            classes = getClasses({
                imageSize: restrictSize(getImageSize(imgWidth), maxSize),
                linkClass,
            });
        }
    }
</script>

<a
    href={linkMetaData.url}
    target={'_blank'}
    class:relative={withButton}
    class={cx('bg-white', classes.linkClass)}
>
    {#if linkMetaData.icon !== null}
        <img
            alt="preview of link"
            bind:naturalWidth={imgWidth}
            class={cx(imgClass, classes.imgClass)}
            src={linkMetaData.icon}
        />
    {/if}
    <div class={cx(contentClass, classes.contentClass)}>
        <div class={cx(titleClass, 'text-brand-blue line-clamp-1')}>
            {linkMetaData.title}
        </div>
        <p class={'text-sm text-gray-700'}>
            {truncate(linkMetaData.description || '', { length: 200 })}
        </p>
    </div>
    {#if withButton}
        <button
            type="button"
            on:click|preventDefault={() => dispatch('buttonclick')}
            class={'absolute top-2 right-2 inline-flex items-center justify-center w-8 h-8 rounded-full text-white bg-black btn-reset hover:opacity-50'}
        >
            <i class="fa fa-times" />
        </button>
    {/if}
</a>
